<div class="lightbox-dialog">
  <!-- Header -->
  <div class="lightbox-header">
    <h2 class="lightbox-title">{{ data.title }}</h2>
    <button mat-icon-button (click)="onClose()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Image Container -->
  <div class="lightbox-content">
    <img [src]="data.imageUrl" [alt]="data.title" class="lightbox-image" />
  </div>

  <!-- Footer Actions -->
  <div class="lightbox-footer">
    <button mat-raised-button color="primary" (click)="onDownload()" class="download-button">
      <mat-icon>download</mat-icon>
      Download Image
    </button>
  </div>
</div>

